const main = () => {
    if (document.querySelector('.c-others-select-search') == null) return;

    document.querySelectorAll('.c-others-select-search').forEach((root) => {
        const trigger = root.querySelector('.c-others-select-search__trigger');
        const label = root.querySelector('.c-others-select-search__label');
        const nativeSelect = root.querySelector('.c-others-select-search__native');
        const options = root.querySelectorAll('.c-others-select-search__option');

        // トリガークリックで開閉
        trigger.addEventListener('click', () => {
            const isOpen = root.hasAttribute('data-open');
            // 他のセレクトを閉じる
            document.querySelectorAll('.c-others-select-search[data-open]').forEach((el) => {
                if (el !== root) el.removeAttribute('data-open');
            });
            if (isOpen) {
                root.removeAttribute('data-open');
            } else {
                root.setAttribute('data-open', '');
            }
        });

        // オプション選択
        options.forEach((option) => {
            option.addEventListener('click', () => {
                const value = option.getAttribute('data-value');
                const text = option.querySelector('.c-others-select-search__option-text').textContent;

                // ラベル更新
                label.textContent = text;

                // 選択状態の更新
                options.forEach((o) => o.removeAttribute('data-selected'));
                option.setAttribute('data-selected', '');

                // hidden selectの値を更新してchangeイベントを発火
                nativeSelect.value = value;
                nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));

                // ドロップダウンを閉じる
                root.removeAttribute('data-open');
            });
        });
    });

    // 外側クリックで閉じる
    document.addEventListener('click', (e) => {
        if (!e.target.closest('.c-others-select-search')) {
            document.querySelectorAll('.c-others-select-search[data-open]').forEach((el) => {
                el.removeAttribute('data-open');
            });
        }
    });
}

export default main;
